/* Judge.me supplies the original cards, aggregates, verification and photo viewer.
   Only the observed Cards Carousel markup receives GDK's native-scroll presentation. */
(function () {
  'use strict';
  if (window.gdkMatchdayReviews) return;
  window.gdkMatchdayReviews = true;
  var observers = new Map();
  var nativeRails = new WeakSet();
  function enhance(section) {
    section.querySelectorAll('.jdgm-cards-carousel').forEach(function (widget) {
      var rail = widget.querySelector('.jdgm-cards-wrapper');
      var track = widget.querySelector('.jdgm-videos-container');
      if (!rail || !track) return;
      var cards = Array.from(track.children).filter(function (card) {
        return card.matches('.jdgm-card[data-review-id]:not([data-clone-type])');
      });
      if (!cards.length) return;
      widget.classList.add('gdk-review-rail');
      if (!nativeRails.has(rail)) {
        // Judge.me's .jdgm-content ancestor cancels horizontal touchmove and
        // advances its translated slider. Keep only native scrolling here;
        // passive handlers never cancel horizontal or vertical browser gestures.
        ['touchstart', 'touchmove', 'touchend', 'touchcancel'].forEach(function (type) {
          rail.addEventListener(type, function (event) { event.stopPropagation(); }, { passive: true });
        });
        nativeRails.add(rail);
      }
      rail.setAttribute('tabindex', '0');
      rail.setAttribute('role', 'region');
      rail.setAttribute('aria-label', 'Reviews from across GameDay Kits. Scroll horizontally for more.');
      cards.forEach(function (card) {
        var product = card.querySelector('.jdgm-product-name');
        // Never show an unattributed card in a store-wide product feed.
        card.hidden = !product || !product.textContent.trim() || product.classList.contains('jdgm-store-review-label');
        var stars = card.querySelector('.jdgm-stars');
        if (stars && stars.children.length === 5) {
          var rating = Array.from(stars.children).reduce(function (sum, star) {
            return sum + (star.classList.contains('jdgm--on') ? 1 : star.classList.contains('jdgm--half') ? .5 : 0);
          }, 0);
          stars.setAttribute('role', 'img');
          stars.setAttribute('aria-label', 'Rated ' + rating + ' out of 5');
          Array.from(stars.children).forEach(function (star) { star.setAttribute('aria-hidden', 'true'); });
        }
        var verified = card.querySelector('.jdgm-reviewer-verified-icon');
        if (verified && !verified.textContent) verified.textContent = 'Verified buyer';
        var body = card.querySelector('.jdgm-text');
        if (body && body.textContent.length > 260 && !card.querySelector('[data-gdk-read-more]')) {
          var more = document.createElement('button');
          more.type = 'button';
          more.className = 'gdk-review-read-more';
          more.setAttribute('data-gdk-read-more', '');
          more.setAttribute('aria-expanded', 'false');
          more.textContent = 'Read more';
          body.classList.add('gdk-review-text--collapsed');
          more.addEventListener('click', function (event) {
            event.stopPropagation();
            var expanded = more.getAttribute('aria-expanded') !== 'true';
            more.setAttribute('aria-expanded', String(expanded));
            more.textContent = expanded ? 'Read less' : 'Read more';
            body.classList.toggle('gdk-review-text--collapsed', !expanded);
          });
          body.after(more);
        }
        var photo = card.querySelector(':scope > img');
        if (photo) {
          var view = document.createElement('button');
          view.type = 'button';
          view.className = 'gdk-review-photo';
          view.setAttribute('aria-label', 'View customer photo for ' + (product ? product.textContent.trim() : 'this review'));
          photo.before(view);
          view.appendChild(photo); // Keep the original image and provider's bubbling lightbox click.
          card.classList.add('gdk-review-card--photo');
          var alt = (photo.getAttribute('alt') || '').trim();
          if (!alt || /^(review image|image|photo|video thumbnail)$/i.test(alt) || /\.(jpe?g|png|webp|gif)(\?.*)?$/i.test(alt)) {
            photo.alt = 'Customer review photo for ' + (product ? product.textContent.trim() : 'this shirt');
          }
          function sizePhoto() {
            if (!photo.naturalWidth || !photo.naturalHeight) return;
            view.hidden = false;
            card.classList.add('gdk-review-card--photo');
            var ratio = photo.naturalWidth / photo.naturalHeight;
            view.style.setProperty('--gdk-review-photo-ratio', String(Math.max(.8, Math.min(1.5, ratio))));
            // Unusually tall or panoramic compositions retain the whole photograph.
            view.classList.toggle('gdk-review-photo--uncropped', ratio < .65 || ratio > 2);
          }
          function hideFailedPhoto() {
            view.hidden = true;
            card.classList.remove('gdk-review-card--photo');
          }
          // Preserve the provider image so a later successful source can recover.
          photo.addEventListener('load', sizePhoto);
          photo.addEventListener('error', hideFailedPhoto);
          if (photo.complete) {
            if (photo.naturalWidth && photo.naturalHeight) sizePhoto();
            else hideFailedPhoto();
          }
        }
      });
      var average = widget.querySelector('.jdgm-average-rating');
      if (average) {
        var raw = average.querySelector('.jdgm-rating-text');
        var countNode = average.querySelector('.jdgm-reviews-count');
        var rating = raw ? Number.parseFloat(raw.textContent) : NaN;
        var count = countNode ? Number(countNode.textContent.replace(/[,\s]/g, '')) : NaN;
        if (Number.isFinite(rating) && rating > 0 && rating <= 5 && Number.isInteger(count) && count > 0) {
          var summary = average.querySelector('[data-gdk-global-summary]') || document.createElement('span');
          summary.setAttribute('data-gdk-global-summary', '');
          // This is the provider's shop aggregate, never the number of cards or PDP metafields.
          var label = rating.toFixed(1) + ' · ' + count + (count === 1 ? ' review' : ' reviews');
          if (summary.textContent !== label) summary.textContent = label;
          if (!summary.parentNode) average.appendChild(summary);
          average.hidden = false;
          raw.hidden = true;
        } else {
          var stale = average.querySelector('[data-gdk-global-summary]');
          if (stale) stale.remove();
          if (raw) raw.hidden = false;
          average.hidden = count === 0;
        }
      }
    });
  }
  function init(root) {
    var sections = Array.from(root.querySelectorAll('[data-matchday-reviews]'));
    if (root.matches && root.matches('[data-matchday-reviews]')) sections.push(root);
    sections.forEach(function (section) {
      if (observers.has(section)) return;
      var observer = new MutationObserver(function () {
        observer.disconnect();
        enhance(section);
        observer.observe(section, { childList: true, subtree: true });
      });
      enhance(section);
      observer.observe(section, { childList: true, subtree: true });
      observers.set(section, observer);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    observers.forEach(function (observer, section) {
      if (event.target === section || event.target.contains(section)) { observer.disconnect(); observers.delete(section); }
    });
  });
})();
